import { IconButton, Tooltip } from '@chakra-ui/react';
import React from 'react';
import { faWind } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import SparkelIcon from 'src/components/common/icon/SparkelIcon';
import { useLocalStorage } from 'src/hooks/local-storage';
import { useUserTenant } from 'src/services/auth-info';

export default function WindLoadZonesToggleButton(): React.ReactElement | null {
  const { isProtan } = useUserTenant();
  const { t } = useTranslation(['project', 'protan']);
  const [isShowingWindLoadZones, setIsShowingWindLoadZones] = useLocalStorage(
    'show-wind-load-zones',
    true
  );

  if (!isProtan) return null;

  const activeIconColor: [string, string] = ['teal.500', 'teal.200'];

  return (
    <Tooltip label={t('protan:visuals.wind-load-zones')}>
      <IconButton
        aria-label={t('protan:visuals.wind-load-zones')}
        icon={
          <SparkelIcon
            icon={faWind}
            color={isShowingWindLoadZones ? activeIconColor : undefined}
          />
        }
        isRound
        isActive={isShowingWindLoadZones}
        colorScheme={isShowingWindLoadZones ? 'teal' : 'gray'}
        variant={isShowingWindLoadZones ? 'toggle' : 'solid-no-transparent'}
        size="xs"
        onClick={() => {
          const next = !isShowingWindLoadZones;
          setIsShowingWindLoadZones(next);
          // Notify shapes to update immediately in this tab
          window.dispatchEvent(
            new CustomEvent('SheetsV2:windLoadZonesToggle', {
              detail: { enabled: next },
            })
          );
        }}
      />
    </Tooltip>
  );
}
